module.exports = __webpack_public_path__ + "static/media/twitter.ac9718cb.svg";